import { BaseFetch } from "../main-model"
export default class ResultRecordModel extends BaseFetch {
  getResultRecordBy = (data) =>
    this.authFetch({
      url: "result-record/getResultRecordBy",
      method: "POST",
      body: JSON.stringify(data),
    })
  getResultRecordById = (data) =>
    this.authFetch({
        url: "result-record/getResultRecordById",
        method: "POST",
      body: JSON.stringify(data),
    })
    updateResultRecordById = (data) =>
    this.authFetch({
      url: "result-record/updateResultRecordById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertResultRecord = (data) =>
    this.authFetch({
      url: "result-record/insertResultRecord",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteResultRecordById = (data) =>
    this.authFetch({
      url: "result-record/deleteResultRecordById",
      method: "POST",
      body: JSON.stringify(data),
    })
}
